import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';

const ArAdjustmentReportRow = ({ rowData, id, nestedColumnsNumber }) => {
  const { purchaserName, purchaserOPI, unitDetails } = rowData;
  return (
    <tr key={id} className="table-body-tr">
      <td width="50px" align="center" className="valign-middle">
        {purchaserOPI}
      </td>
      <td className="valign-middle">
        <div className="mb-1 display-block">{purchaserName}</div>
      </td>
      {[...Array(nestedColumnsNumber)]?.map((_col, column) => {
        return (
          <td key={column} className="p-0 tb-next">
            {unitDetails?.map((rowDataValues, rdIndex) => {
              return (
                <table key={rdIndex} className="inner-table-1">
                  <tbody>
                    {column === 0 && (
                      <tr className="tr-next-1">
                        <td>
                          <p className="contract-number">{rowDataValues?.contractNumber}</p>
                        </td>
                      </tr>
                    )}
                    {column === 1 && (
                      <tr className="tr-next">
                        <td>{getPrice(rowDataValues?.totalContractValue)}</td>
                        <td>{getPrice(rowDataValues?.badDebt)}</td>
                        {/* <td>{getPrice(rowDataValues?.writeOff)}</td> */}
                        <td>{getPrice(rowDataValues?.lateFee)}</td>
                        {/* <td>{getPrice(rowDataValues?.advance)}</td> */}
                        <td>{getPrice(rowDataValues?.promoDiscount)}</td>
                        <td>{getPrice(rowDataValues?.otherDiscount)}</td>
                        <td>{getPrice(rowDataValues?.adjustment)}</td>
                        <td>{getPrice(rowDataValues?.balance)}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              );
            })}
          </td>
        );
      })}
    </tr>
  );
};

ArAdjustmentReportRow.propTypes = {
  rowData: PropTypes.shape({
    purchaserName: PropTypes.string.isRequired,
    purchaserOPI: PropTypes.string.isRequired,
    unitDetails: PropTypes.shape([
      {
        contractNumber: PropTypes.string,
        addendumNumber: PropTypes.shape([]),
        totalContractValue: PropTypes.number,
        badDebt: PropTypes.number,
        writeOff: PropTypes.number,
        lateFee: PropTypes.number,
        advance: PropTypes.number,
        promoDiscount: PropTypes.number,
        otherDiscount: PropTypes.number,
        adjustment: PropTypes.number,
        balance: PropTypes.number,
      },
    ]).isRequired,
  }).isRequired,
  id: PropTypes.number.isRequired,
  nestedColumnsNumber: PropTypes.number.isRequired,
};

export default ArAdjustmentReportRow;
